import type { IAssetSource } from '@monofe/util';
import type { ICycler } from './cycler/cycler.if';

export interface ITextProps {
    text: string;
    fontFamily: string;
    fontSize: string;
    fontAlignment: 'left' | 'center' | 'right' | 'justify';
    fontWeight: number;
    color: string;
    visible: boolean;
}

export interface IImageProps {
    urls: IAssetSource[];
    mode: 'contain' | 'cover';
}

export enum ILanguageSelectType {
    Undef = 0,
    List = 1,
    GridFlag = 2,
    GridTile = 3,
    LastValue = 4,
}

export interface ILanguageSelectItemViewModel {
    title: ITextProps;
    iconUrl: string;
    topSeparatorVisible: boolean;
    topSeparatorColor: string;
    bottomSeparatorVisible: boolean;
    bottomSeparatorColor: string;
    backgroundColor: string;
    cornerRadius: number;

    data?: unknown;
    onClick: string | ((item: ILanguageSelectItemViewModel) => void);
}

export interface ILanguageSelectViewModel {
    title: ITextProps;
    backgroundColor: string;
    backgroundImage: IImageProps;

    items: ILanguageSelectItemViewModel[];
}

export interface ILanguageSelectMainProps {
    model: ILanguageSelectViewModel;
}

export interface ILanguageSelectItemProps {
    model: ILanguageSelectItemViewModel;
}

export interface ILanguageSelectIndexProps {
    model: ILanguageSelectViewModel;
    type: ILanguageSelectType;
}

export interface ILanguageSelectController {
    model: ILanguageSelectControllerModel;
    type: ILanguageSelectType;
    titleCyclerTimeout: ReturnType<typeof setInterval> | null;
    isLoading: boolean;
}

export interface ILanguageSelectControllerModel extends ILanguageSelectViewModel {
    cycler?: ICycler<string>;
    activeTitle: () => string;
    nextTitle: () => string;
    delayBetweenChangingTitle: number;
}
